import { language_codes } from "../api";

const userBrowserLanguage = function () {
  return (navigator.languages && navigator.languages[0]) || navigator.language || "en-GB";
};
export const userBrowserLanguageChar2 = function () {
  const lang = (navigator.languages && navigator.languages[0]) || navigator.language || "en-GB";
  let only_lang = lang.split("-")[0];
  if (!language_codes.includes(only_lang)) {
    only_lang = "en";
  }
  return only_lang;
};

export default userBrowserLanguage;
